import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const SessionDetailsPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.SessionDetailsView />
    </div>
  );
};

export default SessionDetailsPage;
